export default __webpack_public_path__ + "static/media/forestly-expl-07_DE.19f972ce.png";